import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from 'src/app/services/api/category';
import { District } from 'src/app/services/api/district';
import { ProposalStatus } from 'src/app/services/api/proposal-status';
import { ProposalStatusService } from 'src/app/services/api/proposal-status.service';
import { HelpersService } from 'src/app/services/shared/helper.service';
import { ProposalStatusComponent } from '../proposal-status/proposal-status.component';

@Component({
  selector: 'app-filter-allprogram',
  templateUrl: './filter-allprogram.component.html',
  styleUrls: ['./filter-allprogram.component.scss']
})
export class FilterAllprogramComponent {

  status: ProposalStatus[];
  category: Category[];
  district: District[];
  form: FormGroup

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public helper: HelpersService,
    public service: ProposalStatusService,
    public fb: FormBuilder,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProposalStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    console.log(data)
    this.form = this.fb.group({
      district_id: [null],
      category: [null],
      status_id: [null],
      priority: [null],
      is_musrenbang: [null]
    })
    if (data.data) {
      Object.keys(data.data).map(key => {
        if (key != 'categories,category_id') {
          if (this.form.contains(key)) {
            this.form.get(key).setValue(data.data[key].eq)
          } 
        } else {
          this.form.get('category').setValue(data.data[key].eq)
        }
      })
    }
    // this.status = data.status
    this.district = data.district
    this.category = data.category
  }

  onConfirm(): void {
    this.dialogRef.close(this.form.value);
  }
 
  onDismiss(): void {
    this.dialogRef.close(false);
  }

}
